
import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import ProgressOverview from './ProgressOverview';
import ProgressAnalytics from '@/components/gamification/ProgressAnalytics';
import AdaptiveLearning from '@/components/gamification/AdaptiveLearning';
import ProgressStats from './ProgressStats';
import ActivityFeed from './ActivityFeed';
import { UserProgressData } from '@/hooks/useUserProgress';

interface ProgressTabsContentProps {
  allProgress: UserProgressData[];
}

const ProgressTabsContent: React.FC<ProgressTabsContentProps> = ({ allProgress }) => {
  const recentProgress = allProgress.slice(0, 10);

  return (
    <>
      <TabsContent value="overview">
        <ProgressOverview />
      </TabsContent>

      <TabsContent value="analytics">
        <ProgressAnalytics />
      </TabsContent>

      <TabsContent value="recommendations">
        <AdaptiveLearning />
      </TabsContent>

      <TabsContent value="progress" className="space-y-6">
        <ProgressStats progressData={allProgress} />
      </TabsContent>

      <TabsContent value="activity">
        <ActivityFeed recentProgress={recentProgress} />
      </TabsContent>
    </>
  );
};

export default ProgressTabsContent;
